import { useContext } from 'react';
import { NsProgress as BgNsProgress } from '@britishgasenergy/react-nucleus';

import { useGetNextRoute } from 'hooks/useGetNextRoute';
import { RouteScreenContext } from 'components/app/AppContext';

export const NsProgress = () => {
  const { route, routes } = useContext(RouteScreenContext);
  const nextRoute = useGetNextRoute({ routes });
  const next = nextRoute?.name;
  const currentStep = route?.step || 1;
  const steps = ['Get a quote', 'Your tariff quote', 'Account set up'];
  const completed = route?.isEnding;
  const currentStepName = completed
    ? "You're all done"
    : steps[currentStep - 1];

  if (!route) {
    return null;
  }

  return (
    <BgNsProgress
      complete={completed}
      current={currentStep}
      steps={steps.length}
      info={currentStepName}
      next={next}
    />
  );
};
